import requestAccountInfo from 'state/actions/account'
import store from 'state/store'

import getActionCreator from './actions'

const CHANNEL_DELETED_MESSAGE = 'Channel deleted'

export default class ClanRoomChannel {
    constructor(url) {
        this.ws = new WebSocket(url)
        this.ws.onmessage = this.onMessage.bind(this)
    }
    disconnect() {
        if (this.ws !== undefined) {
            this.ws.close()
            this.ws = undefined
        }
    }
    onMessage({ data }) {
        if (data === CHANNEL_DELETED_MESSAGE) {
            this.disconnect()
            store.dispatch(requestAccountInfo())
            return
        }

        const { payload, type } = JSON.parse(data)
        if (!payload || !type) {
            console.error('Invalid action from clan channel', data) // eslint-disable-line no-console
            return
        }

        const actionCreator = getActionCreator(type)
        if (!actionCreator) return

        store.dispatch(actionCreator(payload))
    }
}



// WEBPACK FOOTER //
// ./channels/clan/index.js